@reference "@glow/tailwind-config/reference.css";

/* 2px borders are the 1px border plus a 1px inset shadow, so the size does not shift between states.
   `button.` outranks the Menu button reset that IconMenuButton also gets. */
button.iconButton {
  --icon-button-drop-shadow: 3px 3px 0 0 rgba(0, 0, 0, 0.45);
  @apply inline-flex;
  @apply items-center;
  @apply justify-center;
  @apply shrink-0;
  @apply p-0;
  @apply rounded-sm;
  @apply border;
  @apply border-solid;
  @apply border-gray-300;
  @apply bg-transparent;
  @apply text-emphasis-medium;
  @apply cursor-pointer;
  @apply appearance-none;
}

.sm {
  @apply h-8;
  @apply w-8;
  @apply min-w-8;
  @apply text-base;
}

/* The design system keeps the bordered icon button out of cards and tables, where sm is used,
   so sm has no border until hovered or selected. Same specificity as the base rule, so it must follow it. */
button.sm {
  @apply border-transparent;
}

.md {
  @apply h-10;
  @apply w-10;
  @apply min-w-10;
  @apply text-lg;
}

.iconButton[aria-pressed="true"],
.iconButton[aria-expanded="true"] {
  @apply border-primary-500;
  @apply bg-primary-100;
  @apply text-primary-500;
  box-shadow: inset 0 0 0 1px var(--color-primary-500);
}

.iconButton:hover:not(:disabled) {
  @apply border-gray-500;
  box-shadow:
    inset 0 0 0 1px var(--color-gray-500),
    var(--icon-button-drop-shadow);
}

.iconButton[aria-pressed="true"]:hover:not(:disabled),
.iconButton[aria-expanded="true"]:hover:not(:disabled) {
  @apply border-primary-800;
  @apply text-emphasis-ultra;
  box-shadow:
    inset 0 0 0 1px var(--color-primary-800),
    var(--icon-button-drop-shadow);
}

.iconButton:disabled {
  @apply opacity-30;
  @apply cursor-not-allowed;
}
